<!-- @format -->
<template>
    <div class="na-ad-box-dock has-text-centered">
        <router-link class="is-hidden-mobile" :to="{ name: 'ad' }"
            ><img
                class="na-link na-ad-image"
                :src="imageUrl('NewsAtomic-KWAdvertiseNA2020.png')"
                alt="Advertise on Kingston Wire"
                title="Advertise on Kingston Wire"
                width="250"
                height="250"
                loading="lazy"
        /></router-link>
        <router-link class="is-hidden-tablet" :to="{ name: 'ad' }"
            ><img
                class="na-link na-ad-image"
                :src="imageUrl('NewsAtomic-KWAdvertiseNA2020.png')"
                alt="Advertise on Kingston Wire"
                title="Advertise on Kingston Wire"
                width="250"
                height="250"
                loading="lazy"
        /></router-link>
    </div>
</template>

<script>
import { mediaMixin } from '@/mixins/MediaMixin.js';

export default {
    mixins: [mediaMixin]
};
</script>
